import { useEffect, useMemo } from "react";
import { PERSONAL_INFORMATION } from "@jti/fe-common";
import { useAvpAvailableMethods } from "@jti/rest-api";
export function useAvMethods({ selectedMethod, selectMethod }) {
    const { availableMethods, isAvailableMethodsLoading } = useAvpAvailableMethods();
    useEffect(() => {
        if (!availableMethods?.length || selectedMethod) {
            return;
        }
        // Take first method other then personal information
        const defaultSelectedMethodItem = availableMethods.find((methodItem) => methodItem.code !== PERSONAL_INFORMATION);
        if (defaultSelectedMethodItem) {
            selectMethod(defaultSelectedMethodItem.code);
        }
        else {
            // If there is no other methods available, then select the first one (personal information)
            selectMethod(availableMethods[0].code);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [availableMethods]);
    const method = useMemo(() => {
        return availableMethods?.find((methodItem) => methodItem.code === selectedMethod);
    }, [availableMethods, selectedMethod]);
    const onSelectMethod = (methodCode) => {
        const selectedMethodItem = availableMethods?.find((methodItem) => methodItem.code === methodCode);
        selectMethod(selectedMethodItem?.code ?? "");
    };
    return { availableMethods, isAvailableMethodsLoading, method, onSelectMethod };
}
//# sourceMappingURL=useAvMethods.js.map